import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { constants } from 'common/helpers'
import { useCallback, useState } from 'sb-hooks'

import Icon from 'components/_new/ui/Icon/Icon'
import Button from 'components/_new/Button/Button'
import SocialButton from 'components/_new/buttons/SocialButton/SocialButton'

import messages from './messages'
import s from './GmailButton.scss'


const GmailButton = ({ className, rounded, onClick }) => {
  const [ isFetching, setFetching ] = useState(false)

  const handleClick = useCallback(() => {
    actions.models.me.stopInviteTracking()

    if (typeof onClick === 'function') {
      onClick()
    }

    setFetching(true)
    actions.misc.google.getContacts()
      .then((data) => actions.models.modals.open(constants.modals.ChooseFriendsToInvite, data))
      .finally(() => setFetching(false))
  }, [ onClick ])

  return rounded ? (
    <Button
      className={cx(s.roundButton, className)}
      size="md"
      color={null}
      loading={isFetching}
      ariaLabel="Share on Gmail"
      dataTestId={constants.testIds.invite.googleButton}
      onClick={handleClick}
    >
      <Icon
        className={s.icon}
        name="google"
        color={null}
      />
    </Button>
  ) : (
    <SocialButton
      title={messages.buttonTitle}
      size="md"
      type="google"
      ariaLabel="Share on Gmail"
      loading={isFetching}
      dataTestId={constants.testIds.invite.googleButton}
      fullWidthOnMobile
      onClick={handleClick}
    />
  )
}


GmailButton.propTypes = {
  onClick: PropTypes.func,
}

export default GmailButton
